







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import DropOffBody from '@/components/drop-off/DropOffBody.vue';

@Component({
    components: {GlobalHeader, DropOffBody}
})
export default class DropOffs extends Vue {
  
}
